<template>
  <footer class="bg-gray-900 text-gray-300 mt-8">
    <div class="container mx-auto px-4 py-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <!-- Description -->
        <div>
          <h3 class="text-white text-lg font-semibold mb-3">GDExpert</h3>
          <p class="text-sm leading-relaxed text-justify">
            GDExpert propose une offre complète qui couvre l'ensemble de la chaîne d'acquisition documentaire, depuis la numérisation jusqu'au stockage d'information. En tant que distributeur à valeur ajoutée, notre rôle réside principalement dans le choix des solutions les plus performantes et reconnues sur le marché de la dématérialisation et de l'archivage. GDExpert propose son offre logicielle et matérielle sur les territoires du Maghreb et de l'Afrique Francophone, à travers un réseau de partenaires implantés localement.
          </p>
        </div>
        
        <!-- Adresse & Contact -->
        <div class="md:pl-32">
          <h3 class="text-white text-lg font-semibold mb-3">Contact</h3>
          <div class="space-y-3">
            <address class="not-italic text-sm">
              <strong class="text-white">GDExpert</strong><br/>
              12 boulevard Georges Marie Guynemer,<br/>
              78210 Saint-Cyr-l'Ecole
            </address>
            
            <div class="text-sm space-y-1.5">
              <p>
                <span class="text-gray-400">Email :</span> 
                <a href="mailto:contact@gdexpert.net" class="text-[#f39c12] hover:text-[#e67e22] transition-colors">
                  contact@gdexpert.net
                </a>
              </p>
              <p>
                <span class="text-gray-400">Tél :</span> 
                <span class="text-white">+33(0) 1 88 590 590</span>
              </p>
            </div>
            
            <!-- Réseaux sociaux -->
            <div class="flex items-center gap-3 pt-2">
              <a href="https://www.facebook.com/GlobalDocumentExpert?ref=nf&hc_ref=ARQXbaMkchLr9CovL3vc7JqtV3SAG4vTThtpQf-dXhND5RkmMBKyXVW2UPxZP6wt4b4#" target="_blank" rel="noopener noreferrer" aria-label="Facebook" class="text-gray-400 hover:text-[#f39c12] transition-colors">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M22 12.07C22 6.48 17.52 2 11.93 2S1.86 6.48 1.86 12.07c0 5.01 3.66 9.17 8.44 9.93v-7.02H7.9v-2.9h2.4V9.41c0-2.38 1.42-3.69 3.6-3.69 1.04 0 2.13.18 2.13.18v2.34h-1.2c-1.19 0-1.56.74-1.56 1.5v1.8h2.65l-.42 2.9h-2.23V22c4.78-.76 8.44-4.92 8.44-9.93z"/>
                </svg>
              </a>
              <a href="https://x.com/GDExpert?lang=fr" target="_blank" rel="noopener noreferrer" aria-label="X" class="text-gray-400 hover:text-[#f39c12] transition-colors">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/gd-expert" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" class="text-gray-400 hover:text-[#f39c12] transition-colors">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19 3A2.94 2.94 0 0122 6v12a2.94 2.94 0 01-3 3H5a2.94 2.94 0 01-3-3V6a2.94 2.94 0 013-3zm-9.75 16.5V9.75H6.25V19.5zm-1.5-11.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM19.5 19.5v-5.16c0-2.76-1.47-4.04-3.43-4.04a2.96 2.96 0 00-2.67 1.47h-.04V9.75h-3v9.75h3v-5.4c0-1.42.27-2.79 2.03-2.79 1.74 0 1.77 1.58 1.77 2.88v5.31z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

